/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ spread: NonNullable<unknown> }} Body_Assessment_Warning_Diagnostic_SpreadInputs */

const en_us2_body_assessment_warning_diagnostic_spread = /** @type {(inputs: Body_Assessment_Warning_Diagnostic_SpreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The diagnostic equations disagreed by ${i?.spread} pp with each other. Retake the photos if you can.`)
};

const pt_br2_body_assessment_warning_diagnostic_spread = /** @type {(inputs: Body_Assessment_Warning_Diagnostic_SpreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As equações de diagnóstico divergiram ${i?.spread} p.p. entre si. Se der, refaça as fotos.`)
};

const es_419_body_assessment_warning_diagnostic_spread = /** @type {(inputs: Body_Assessment_Warning_Diagnostic_SpreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Las ecuaciones de diagnóstico difirieron ${i?.spread} p. p. entre sí. Si puedes, vuelve a tomar las fotos.`)
};

const pt_pt2_body_assessment_warning_diagnostic_spread = /** @type {(inputs: Body_Assessment_Warning_Diagnostic_SpreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As equações de diagnóstico divergiram ${i?.spread} p.p. entre si. Se puderes, repete as fotos.`)
};

const fr_fr2_body_assessment_warning_diagnostic_spread = /** @type {(inputs: Body_Assessment_Warning_Diagnostic_SpreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les équations de diagnostic divergeaient de ${i?.spread} pts entre elles. Reprends les photos si tu peux.`)
};

const de_de2_body_assessment_warning_diagnostic_spread = /** @type {(inputs: Body_Assessment_Warning_Diagnostic_SpreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die diagnostischen Gleichungen wichen um ${i?.spread} Pp. voneinander ab. Mach die Fotos neu, wenn du kannst.`)
};

const it_it2_body_assessment_warning_diagnostic_spread = /** @type {(inputs: Body_Assessment_Warning_Diagnostic_SpreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le equazioni diagnostiche differivano di ${i?.spread} p.p. tra loro. Se puoi, rifai le foto.`)
};

/**
* | output |
* | --- |
* | "The diagnostic equations disagreed by {spread} pp with each other. Retake the photos if you can." |
*
* @param {Body_Assessment_Warning_Diagnostic_SpreadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_diagnostic_spread = /** @type {((inputs: Body_Assessment_Warning_Diagnostic_SpreadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_Diagnostic_SpreadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_diagnostic_spread(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_diagnostic_spread(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_diagnostic_spread(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_diagnostic_spread(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_diagnostic_spread(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_diagnostic_spread(inputs)
	return en_us2_body_assessment_warning_diagnostic_spread(inputs)
});
export { body_assessment_warning_diagnostic_spread as "body-assessment.warning.diagnostic_spread" }